"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionPages = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var Section = styled_components_1.default.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  grid-column: 4 / span 3;\n  padding: 0;\n\n  ", "\n\n  .list--pages {\n    align-self: flex-end;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    list-style-type: none;\n    margin-bottom: ", ";\n\n\n    ", "\n\n    li {\n      align-items: center;\n      display: flex;\n      margin-bottom: ", ";\n\n      ", "\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      color: ", ";\n      display: inline-block;\n      font-family: ", ";\n      ", "\n      font-size: ", ";\n      opacity: 1;\n      text-decoration: none;\n      transition: 300ms opacity ease-out;\n\n      &:hover {\n        opacity: .4;\n      }\n    }\n  }\n"], ["\n  grid-column: 4 / span 3;\n  padding: 0;\n\n  ", "\n\n  .list--pages {\n    align-self: flex-end;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    list-style-type: none;\n    margin-bottom: ", ";\n\n\n    ", "\n\n    li {\n      align-items: center;\n      display: flex;\n      margin-bottom: ", ";\n\n      ", "\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    a {\n      color: ", ";\n      display: inline-block;\n      font-family: ", ";\n      ", "\n      font-size: ", ";\n      opacity: 1;\n      text-decoration: none;\n      transition: 300ms opacity ease-out;\n\n      &:hover {\n        opacity: .4;\n      }\n    }\n  }\n"])), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    align-items: flex-end;\n    grid-column: 6 / span 2;\n    grid-row: 1 / span 2;\n  "], ["\n    align-items: flex-end;\n    grid-column: 6 / span 2;\n    grid-row: 1 / span 2;\n  "]))), (0, styles_1.getRelative)(10, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "]))), (0, styles_1.getRelative)(15, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        margin-bottom: ", ";\n      "], ["\n        margin-bottom: ", ";\n      "])), (0, styles_1.getRelative)(15, 'desktop')), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.basier;
}, (0, styles_1.getP15_1)(), (0, styles_1.getRelative)(15, 'mobile'));
var pathGenerator = {
    'content': function (slug, url) { return url + "/page/".concat(slug); },
    'faqs': function (slug, url) { return slug ? url + "/faqs/".concat(slug) : url + '/faqs'; },
    'product': function (slug, url) { return url + "/product/".concat(slug); },
    'shop': function (slug, url) { return url + "/shop/".concat(slug); },
    'category': function (slug, url) { return url + "/shop/".concat(slug); }
};
var getPagesLink = function (pages, locale, url) {
    if (url === void 0) { url = 'https://staging.es.hellomamma.eu'; }
    return pages.map(function (page, idx) {
        var type = page.type, title = page.title, _a = page.url, pageType = _a.page, slug = _a.slug;
        var path = pathGenerator[pageType](slug === null || slug === void 0 ? void 0 : slug[locale], url);
        if (!title)
            return null;
        return ((0, jsx_runtime_1.jsx)("li", { children: type === 'external' ?
                (0, jsx_runtime_1.jsx)("a", __assign({ href: slug[locale], rel: 'noreferrer', target: '_blank', title: title }, { children: title }))
                :
                    (0, jsx_runtime_1.jsx)("a", __assign({ href: path, title: title }, { children: title })) }, "footer-pages-".concat(idx)));
    });
};
var isStaging = function () { return window.location.href.includes('staging'); };
var ROUTES = {
    'ES': {
        'es': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.es"); },
        'it': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.es/it"); },
    },
    'FR': {
        'fr': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.fr"); },
        'it': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.fr/it"); },
    },
    'GB': {
        'en': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.co.uk"); },
        'it': function (staging) { return "https://".concat(staging ? 'staging.' : '', "hellomamma.co.uk/it"); },
    },
};
var getCookies = function (name) {
    var e_1, _a;
    var nameEQ = "".concat(name, "=");
    if (typeof window === 'undefined')
        return null;
    var arrayOfCookies = document.cookie.split(';');
    try {
        for (var arrayOfCookies_1 = __values(arrayOfCookies), arrayOfCookies_1_1 = arrayOfCookies_1.next(); !arrayOfCookies_1_1.done; arrayOfCookies_1_1 = arrayOfCookies_1.next()) {
            var rawCookie = arrayOfCookies_1_1.value;
            var cookie = rawCookie;
            while (cookie.charAt(0) == ' ')
                cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) == 0)
                return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arrayOfCookies_1_1 && !arrayOfCookies_1_1.done && (_a = arrayOfCookies_1.return)) _a.call(arrayOfCookies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
};
exports.SectionPages = (0, react_1.memo)(function (_a) {
    var pages = _a.pages;
    var _b = __read((0, react_1.useState)(getPagesLink(pages, 'es')), 2), Pages = _b[0], setPages = _b[1];
    (0, react_1.useEffect)(function () {
        var NEXT_LOCALE = getCookies('NEXT_LOCALE');
        var NEXT_REGION = getCookies('NEXT_REGION');
        var url = 'https://staging.es.hellomamma.eu';
        var staging = isStaging();
        if (NEXT_LOCALE && NEXT_REGION && ROUTES[NEXT_REGION][NEXT_LOCALE](staging)) {
            url = ROUTES[NEXT_REGION][NEXT_LOCALE](staging);
        }
        setPages(getPagesLink(pages, NEXT_LOCALE, url));
    }, []);
    return ((0, jsx_runtime_1.jsx)(Section, { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: 'list--pages' }, { children: Pages })) }));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
